export default __webpack_public_path__ + "static/media/copy.67d82d54.svg";